import { Pipe, PipeTransform } from "@angular/core";
import { GeneroEnum, obtenerNombreGenero } from "@shared/enums";

@Pipe({
    name: "nombreGenero"
})
export class NombreGeneroPipe implements PipeTransform {

    transform(genero: GeneroEnum): string {
        return obtenerNombreGenero(genero);
    }

}
